
import React from 'react';
import VideoCard from './VideoCard';

const videoData = [
  {
    id: 'v1',
    title: 'What is GLP-1 & How Does It Reduce Appetite & Promote Weight Loss? | Dr. Andrew Huberman',
    videoId: 'B8staZOc_xQ'
  },
  {
    id: 'v2',
    title: 'Menstruation, Menopause, and Hormone Replacement Therapy for Women',
    videoId: 'uEZpg0n7jcY'
  },
  {
    id: 'v3',
    title: 'Can GLP-1 agonists like Ozempic, Wegovy, and Mounjaro be used to treat addiction? | Anna Lembke',
    videoId: '0Aqz8mwtHZE'
  },
  {
    id: 'v4',
    title: 'Clinical Trial Finds Weight Loss Medication Reduces Heart Events',
    videoId: 'WtxpwMvzmoE'
  },
  {
    id: 'v5',
    title: 'How Do Ozempic, Mounjaro & Other GPL-1 Agonists Work? | Dr. Zachary Knight & Dr. Andrew Huberman',
    videoId: 'zRXC2pEbj5w'
  },
  {
    id: 'v6',
    title: 'Testosterone & Testosterone Replacement Therapy (TRT) | Dr. Peter Attia & Dr. Andrew Huberman',
    videoId: 'H64KAkM0wF4'
  }
];

const VideosGrid = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8">
      {videoData.map((video) => (
        <VideoCard 
          key={video.id}
          title={video.title}
          videoId={video.videoId}
        />
      ))}
    </div>
  );
};

export default VideosGrid;
